var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M15.199 6.473c-1.914 0-3.495-1.223-5.9-1.223-.892 0-1.69.154-2.431.422.103-.264.146-.546.128-.828-.063-1-.896-1.802-1.913-1.842C3.942 2.956 3 3.854 3 4.969c0 .669.34 1.26.857 1.615v13.572a.85.85 0 00.857.844h.572a.85.85 0 00.857-.844v-3.319c1.011-.424 2.27-.777 4.087-.777 1.914 0 3.494 1.223 5.9 1.223 1.72 0 3.096-.573 4.376-1.437.31-.209.494-.556.494-.926V6.373c0-.822-.867-1.366-1.624-1.02-1.227.56-2.731 1.12-4.177 1.12z"
  }))));
}

export default SvgFlag;